import preact, { createContext } from 'preact'
import { useContext } from 'preact/hooks'

const PbPropsContext = createContext<any | undefined>(undefined)

export const usePbProps = <T extends unknown>() => {
    const context = useContext(PbPropsContext)
    if (!context) {
        throw new Error('Invalid PbPropsProvider')
    }
    return context as T
}

export const PbPropsProvider: preact.FunctionalComponent<{ value: any }> = ({
    value,
    children
}) => (
    <PbPropsContext.Provider value={value}>{children}</PbPropsContext.Provider>
)
